import API from "../api";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allCases: null,
};

const allIndiaSlice = createSlice({
  name: "allIndia",
  initialState,
  reducers: {
    setAllDetails(state, { payload }) {
      state.allCases = payload;
    },
  },
});
export const { setAllDetails } = allIndiaSlice.actions;
export default allIndiaSlice.reducer;

//thunks
export const getAllIndianCases = () => async (dispatch) => {
  try {
    const res = await API.get("/");
    dispatch(setAllDetails(res.data));
  } catch (err) {
    console.log(err.response.data.error);
  }
};
